var exports = {
  "kL": "x804f0401--98323b--container",
  "DD": "x804f0401--98323b--title",
  "Qq": "x804f0401--98323b--text",
};

module.exports = exports;
